export const ParameterContent_defaule = ['Mobile', 'Name', 'CustomerID']